module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_complaints", [["div",{"class":"site-page privacy"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title editor-wrapper","data-fox-alias":"ComplaintsTitle","data-fox-context":"complaints"},[["p",{},[["textNode",{"text":"Complaints Policy"}]]]]]]]]],["section",{"class":"static-page-content"},[["div",{"class":"page-width static-page-docs"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/complaints.tpl
// module id = 1082
// module chunks = 4